function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.967 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.01 3A7.95 7.95 0 0 0 3.9 14.509l-.91 3.664a.658.658 0 0 0 .775.812l3.689-.9A7.956 7.956 0 1 0 11.01 3zm.39 11.263a.523.523 0 0 1-.584.584H10.3a.523.523 0 0 1-.615-.584v-.43a.523.523 0 0 1 .615-.584h.51a.523.523 0 0 1 .584.584zm.055-2.281-.031.129c-.08.289-.227.381-.559.381h-.615a.523.523 0 0 1-.615-.615v-.1c0-1.131 1.672-1.6 1.672-2.459a.7.7 0 0 0-.756-.615 1.267 1.267 0 0 0-.551.15.615.615 0 0 1-.861-.141l-.263-.382c-.209-.314-.221-.578.1-.781a3.2 3.2 0 0 1 1.771-.523A2.248 2.248 0 0 1 13.2 9.117c.055 1.66-1.549 2.035-1.752 2.865z",
    transform: "translate(-2.964 -3)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleQuestionMark);
export default __webpack_public_path__ + "static/media/bubble-question-mark.c97ab738.svg";
export { ForwardRef as ReactComponent };